import { Chip, SxProps } from '@mui/material';

type CompoundLabelChipProps = {
  label: string;
  backgroundColor: string;
  fontColor: string;
  additionalSx?: SxProps;
};

const CompoundLabelChip = ({ label, backgroundColor, fontColor, additionalSx = {} }: CompoundLabelChipProps) => {
  return (
    <Chip
      label={
        <div
          style={{
            textAlign: 'center',
          }}
        >
          {label}
        </div>
      }
      sx={{
        backgroundColor: backgroundColor,
        color: fontColor,
        minWidth: 0,
        maxWidth: '114px',
        height: '21px',
        fontWeight: 400,
        fontSize: '12px',
        borderRadius: '16px',
        display: 'inline-flex',
        padding: '2px 8px 2px 6px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px',
        cursor: 'default',
        '& .MuiChip-label': {
          padding: '0',
        },
        ...additionalSx,
      }}
    />
  );
};

export default CompoundLabelChip;
